import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import es from 'vuetify/es5/locale/es';
import checkboxStarOn from '@core/components/checkboxStarOn';

Vue.use(Vuetify);
const vuetify = new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#032C58',
        secondary: '#FFDD01',
        accent: '#ffc107',
        error: '#f44336',
        warning: '#ff9800',
        info: '#607d8b',
        success: '#4caf50'
      }
    }
  },
  lang: {
    locales: { es },
    current: 'es',
  },
  icons: {
    iconfont: 'mdi',
    values: {
      checkboxStarOff: 'far fa-star',
      checkboxStarOn: {
        component: checkboxStarOn
      }
    }
  }
});
export { vuetify };
